import React from 'react';

import {
  InstagramLogo,
  LinkedinLogo,
  YoutubeLogo,
} from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import logo from 'src/assets/4i-logo.svg';
import { TrackGoogleAnalyticsEvent } from 'src/utils/google-analytics';

import {
  CompanyContent,
  Container,
  SiteContent,
  SocialMediaContent,
  WorkContent,
} from './styles';

export function Footer() {
  const { t: translate } = useTranslation();

  const location = useLocation();

  return (
    <Container>
      <SiteContent>
        <img src={logo} alt="4intelligence logo" />

        <p>Better forecasts, better decisions</p>

        <span>© 2023 4intelligence</span>
      </SiteContent>

      {/* <CompanyContent
        data-tooltip-html={translate('soon') ?? ''}
        data-tooltip-id="footer-soon-tooltip"
      >
        <h3>{translate('product')}</h3>

        <p>Feature Store</p>
        <p>Time Series</p>
        <p>Classificação</p>
        <p>Geocast</p>
      </CompanyContent> */}

      <CompanyContent>
        <h3>4intelligence</h3>

        {/* <p
          data-tooltip-html={translate('soon') ?? ''}
          data-tooltip-id="footer-soon-tooltip"
        >
          {translate('section')}
        </p> */}

        <Link
          to="/cases"
          rel="noreferrer"
          data-testid="cases-button"
          onClick={() => {
            TrackGoogleAnalyticsEvent(
              'Footer - Cases',
              'Ir para tela de cases',
              location.pathname,
            );
          }}
        >
          {translate('cases')}
        </Link>

        {/* <p
          data-tooltip-html={translate('soon') ?? ''}
          data-tooltip-id="footer-soon-tooltip"
        >
          {translate('about')}
        </p> */}

        <Link
          to={process.env.REACT_APP_PRIVACY_POLICY ?? ''}
          target="_blank"
          rel="noreferrer"
          data-testid="privacy-policy-button"
          onClick={() => {
            TrackGoogleAnalyticsEvent(
              'Footer - Link Política de Privacidade',
              'Visualizer arquivo da política de privacidade',
              location.pathname,
            );
          }}
        >
          {translate('privacyPolicy')}
        </Link>

        <Link
          to={process.env.REACT_APP_PRODUCT_TERMS_OF_USE ?? ''}
          target="_blank"
          rel="noreferrer"
          data-testid="terms-of-use-button"
          onClick={() => {
            TrackGoogleAnalyticsEvent(
              'Footer - Link Termos de uso',
              'Visualizer arquivo dos termos de uso',
              location.pathname,
            );
          }}
        >
          {translate('termsOfUse')}
        </Link>
      </CompanyContent>

      <CompanyContent>
        <h3>{translate('footerSocialMedia')}</h3>

        <div>
          <SocialMediaContent>
            <Link
              to="https://www.linkedin.com/company/4intelligence-ai/"
              target="_blank"
              rel="noreferrer"
              aria-label={translate('footerLinkedinLabel') ?? ''}
              data-cy="linkedin-button"
              data-testid="linkedin-button"
              onClick={() => {
                TrackGoogleAnalyticsEvent(
                  'Footer - Linkedin',
                  'Acessar linkedin',
                  location.pathname,
                );
              }}
            >
              <LinkedinLogo weight="fill" />
            </Link>

            <Link
              to="https://www.instagram.com/4.intelligence.ai/"
              target="_blank"
              rel="noreferrer"
              aria-label={translate('footerInstagramLabel') ?? ''}
              data-cy="instagram-button"
              data-testid="instagram-button"
              onClick={() => {
                TrackGoogleAnalyticsEvent(
                  'Footer - Instagram',
                  'Acessar instagram',
                  location.pathname,
                );
              }}
            >
              <InstagramLogo weight="fill" />
            </Link>

            <Link
              to="https://www.youtube.com/@4intelligenceltda/"
              target="_blank"
              rel="noreferrer"
              aria-label={translate('footerYoutubeLabel') ?? ''}
              data-cy="youtube-button"
              data-testid="youtube-button"
              onClick={() => {
                TrackGoogleAnalyticsEvent(
                  'Footer - YouTube',
                  'Acessar YouTube',
                  location.pathname,
                );
              }}
            >
              <YoutubeLogo weight="fill" />
            </Link>
          </SocialMediaContent>

          <WorkContent>
            <Link
              to="https://4intelligence.gupy.io/"
              target="_blank"
              rel="noreferrer"
              data-cy="gupy-button"
              data-testid="gupy-button"
              onClick={() => {
                TrackGoogleAnalyticsEvent(
                  'Footer - Trabalhe conosco',
                  'Acessar gupy',
                  location.pathname,
                );
              }}
            >
              🚀 <p>{translate('footerWorkWithUs')}</p>
            </Link>
          </WorkContent>
        </div>
      </CompanyContent>
    </Container>
  );
}
